module.exports = "<p>\n  companies works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/companies/companies.component.html
// module id = ./src/app/companies/companies.component.html
// module chunks = main